import './Loader.css'

const sizesButton = {
  md: 'h-[16px] w-[16px]',
}

const themesButtons = {
  light: 'border-[white_white_transparent]',
  dark: 'border-[black_black_transparent]',
}

type ButtonLoaderProps = {
  size?: keyof typeof sizesButton
  theme?: keyof typeof themesButtons
  className?: string
  buttonType?: boolean
}

const ButtonLoader = ({
  size = 'md',
  theme = 'light',
  className = '',
}: ButtonLoaderProps) => {
  const classNames = [
    'animate-spin',
    'rounded-full',
    'border-2',
    'border-solid',
    'inline-block',
    'clip-loader',
    sizesButton[size],
    themesButtons[theme],
    className,
  ]
  return <div className={classNames.join(' ')} />
}

export default ButtonLoader
